import React from 'react';
import { Box, Text } from '@chakra-ui/core';
import { colors } from '@styles/theme-chakra';

const Button = ({
  onClick,
  large = false,
  text,
  variant,
  style: propsStyle = {},
  disabled = false,
  fontSize,
  ...props
}) => {
  let style = {
    borderRadius: '8px',
    padding: large ? '0.5rem 2rem' : '0 1rem',
    backgroundColor: colors.greenPea,
    color: colors.white
  };

  let hoverStyle = {
    backgroundColor: `${colors.greenPeaHover} !important`
  };

  if (disabled) {
    style = { ...style, backgroundColor: colors.lightGray, color: colors.boulder };
  } else if (variant === 'primary') {
    style = { ...style };
  } else if (variant === 'secondary') {
    style = {
      ...style,
      backgroundColor: colors.greenLight,
      color: colors.primary
    };
    hoverStyle = {
      backgroundColor: `${colors.greenLightHover} !important`
    };
  } else if (variant === 'dark') {
    style = {
      ...style,
      backgroundColor: colors.darkGreen,
      color: colors.white
    };
  } else if (variant === 'white') {
    style = {
      ...style,
      backgroundColor: colors.white,
      color: colors.black
    };
    hoverStyle = {
      color: `${colors.white} !important`,
      backgroundColor: `${colors.greenPea} !important`
    };
  } else if (variant === 'black') {
    style = {
      ...style,
      backgroundColor: colors.black,
      color: colors.white
    };
    hoverStyle = {
      color: `${colors.black} !important`,
      backgroundColor: `${colors.white} !important`
    };
  } else if (variant === 'outlineDark') {
    style = {
      ...style,
      backgroundColor: 'transparent',
      color: colors.primary,
      border: `1px solid ${colors.primary}`,
      height: '2.5rem'
    };
    hoverStyle = {
      backgroundColor: `${colors.iceberg} !important`,
      color: colors.primary
    };
  }

  if (variant === 'transparent') {
    style = {
      ...style,
      backgroundColor: 'transparent',
      color: colors.black,
      border: `1px solid ${colors.black}`
    };
    hoverStyle = {
      backgroundColor: `${colors.greenPea} !important`,
      color: `${colors.white} !important`
    };
  }

  if (variant === 'whitepea') {
    style = {
      ...style,
      backgroundColor: 'transparent',
      color: colors.white,
      border: `1px solid ${colors.white}`
    };
    hoverStyle = {
      backgroundColor: `${colors.greenPeaHover} !important`,
      color: `${colors.white} !important`
    };
  }

  if (variant === 'pea') {
    style = {
      ...style,
      backgroundColor: colors.greenPea,
      color: colors.iceberg,
      border: `1px solid ${colors.greenPea}`,
      height: '2.5rem'
    };
    hoverStyle = {
      backgroundColor: `${colors.darkGreenHover} !important`,
      textColor: `${colors.iceberg} !important`
    };

    if (disabled) {
      style = { ...style, backgroundColor: colors.boulder, color: colors.iceberg };
      hoverStyle = {
        backgroundColor: null
      };
    }

    return (
      <Text
        disabled={disabled}
        as="button"
        _hover={{
          ...hoverStyle
        }}
        onClick={onClick}
        style={{ ...style, ...propsStyle }}
        background={colors.iceberg}
        color={colors.greenPea}
        fontWeight={500}
        fontSize="14px"
        {...props}
      >
        {text}
      </Text>
    );
  }

  return (
    <Box
      as="button"
      style={{ ...style, ...propsStyle }}
      _hover={{ ...hoverStyle }}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      <Text fontSize={fontSize} fontWeight="semibold">
        {text}
      </Text>
    </Box>
  );
};

export default Button;
